export default __webpack_public_path__ + "static/5.c04b413e3bfd27303ebf1e90b133813c.png";